import { createContext, useCallback, useEffect, useReducer } from 'react';

export const AppStateContext = createContext();

const AppStateProvider = ({ children }) => {
    const [state, dispatch,] = useReducer(
        (state, action) => {
            return {
                ...state,
                [action.key]: action.value
            }
        },
        {
            selectedRepairs: [],
            selectedUpsales: [],
            selectedShop: null,
            selectedDate: null,
            deliveryTime: null,
            pickupDate: null,
            pickupTime: null,
            timeOption: null,
            countryCode: {
                value: "+45",
                valid: true
            },
            company: false,
            plate: {
                value: "",
                valid: false
            },
            mileage: "",
            name: {
                value: "",
                valid: false
            },
            email: {
                value: "",
                valid: false
            },
            phone: {
                value: "",
                valid: false
            },
            comment: "",
            postalCode: "",
            newsletter: false,
            city: "",
            bodyType: null,
            withCar: false,
            getCall: null,
            cvr: "",
            initialProductsAdded: false,
            repairComment: "",
            coupons: ""
        }
    )

    const dispatchMultiple = useCallback(arr => {
        arr.forEach(action => dispatch(action))
    }, [dispatch])

    useEffect(() => {
        dispatchMultiple([
            {
                key: "deliveryTime",
                value: null
            },
            {
                key: "pickupTime",
                value: null
            }
        ])
    }, [state.selectedShop, state.selectedDate, dispatchMultiple])

    useEffect(() => {
        dispatch({
            key: "pickupTime",
            value: null
        })
    }, [state.deliveryTime])
    /* 
        React.useEffect(() => {
        console.log(state)
        }, [state]) */

    useEffect(() => {

        if (state.timeOption === 4) {
            dispatchMultiple([
                {
                    key: "deliveryTime",
                    value: null
                }
            ])
        }

        if (state.timeOption === 2) {
            dispatchMultiple([
                {
                    key: "pickupTime",
                    value: null
                },
                {
                    key: "pickupDate",
                    value: null
                },
                {
                    key: "deliveryTime",
                    value: null
                }
            ])
        }

        if (state.timeOption === 4) {
            dispatchMultiple([
                {
                    key: "pickupTime",
                    value: null
                },
                {
                    key: "pickupDate",
                    value: null
                }
            ])
        }

        if (state.timeOption === 1) {
            dispatchMultiple([
                {
                    key: "pickupTime",
                    value: null
                },
                {
                    key: "pickupDate",
                    value: null
                }
            ])
        }

    }, [state.timeOption, dispatchMultiple])

    return (
        <AppStateContext.Provider
            value={{
                state,
                dispatch,
                dispatchMultiple
            }}
        >
            {
                children
            }
        </AppStateContext.Provider>
    )
}

export default AppStateProvider;